<div class="tms-import-result-container" *ngIf="result">

    <app-tms-import-load-list-result [successes]="result.creationSuccesses" [failures]="result.creationFailures"
                                     [type]="ImportTmsLoadType.CREATION"></app-tms-import-load-list-result>

    <app-tms-import-load-list-result [successes]="result.updateSuccesses" [failures]="result.updateFailures"
                                     [type]="ImportTmsLoadType.UPDATE"></app-tms-import-load-list-result>

    <app-tms-import-load-list-result [successes]="result.removalSuccesses" [failures]="result.removalFailures"
                                     [type]="ImportTmsLoadType.REMOVAL"></app-tms-import-load-list-result>

</div>
